import { render } from "./PatientDocument.vue?vue&type=template&id=237d42f0&ts=true"
import script from "./PatientDocument.ts?vue&type=script&lang=ts&external"
export * from "./PatientDocument.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__